import { render, staticRenderFns } from "./LMSDescript.vue?vue&type=template&id=fa554d24&scoped=true"
var script = {}
import style0 from "./LMSDescript.vue?vue&type=style&index=0&id=fa554d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa554d24",
  null
  
)

export default component.exports